import { DataModel } from "@toolpad/core/Crud";

import { IBatteryStationDto } from "../generated/api-client";
import { nameof } from "../utils/object.utils";
import MagicCrud, { MagicCrudFields } from "../components/MagicCrud";

type BatteryStationDtoDataModel = IBatteryStationDto & DataModel;

export default function BatteryStationsPage() {
  const columns: MagicCrudFields<IBatteryStationDto>[] = [
    {
      field: nameof<IBatteryStationDto>("id"),
      type: "number",
      extraType: "guid",
    },
    {
      field: nameof<IBatteryStationDto>("serialNumber"),
      type: "string",
      isRequired: true,
    },
    {
      field: nameof<IBatteryStationDto>("name"),
      type: "string",
    },
    {
      field: nameof<IBatteryStationDto>("address"),
      type: "string",
    },
    {
      field: nameof<IBatteryStationDto>("availableBatteries"),
      type: "number",
      editable: false,
    },
    {
      field: nameof<IBatteryStationDto>("spareBatteries"),
      type: "number",
    },
    {
      field: nameof<IBatteryStationDto>("updateDate"),
      type: "dateTime",
      editable: false,
    },
  ];

  return (
    <MagicCrud<BatteryStationDtoDataModel>
      name="batteryStation"
      apiUrl="battery-stations"
      columns={columns}
      appUrl="/battery-stations"
    />
  );
}
